import { createFileRoute, redirect } from "@tanstack/react-router";
import { SupportPage } from "@/app/partner/pages/support";
import { canAccessRoute } from "@/lib/auth";

export const Route = createFileRoute("/flex/dashboard/support")({
	beforeLoad: async ({ context }) => {
		const { partner } = context;
		const access = canAccessRoute(partner, "support");

		if (!access.allowed) {
			throw redirect({ to: "/flex/dashboard" });
		}
	},
	component: SupportPage,
});
